<template>
    <section class="section">
        <div class="container">
            <h3>{{ this.$t('shopEuropamaut.productName') }}</h3>

            <div v-for="component in this.order.combined_orders" :key="component.id">
                <combined-order-detail
                    :super-order="order"
                    :order="component"
                ></combined-order-detail>
            </div>
        </div>
    </section>
</template>

<script>
import CombinedOrderDetail from './CombinedOrderDetail.vue';

export default {
    components: { CombinedOrderDetail },
    props: {
        order: {
            type: Object,
            required: true,
        },
    },
};
</script>
